import TiptapListItem from '@tiptap/extension-list-item';

export const ListItem = TiptapListItem.extend({
  content: '(paragraph | heading) block*',
});
